module.exports = __webpack_public_path__ + "img/checklist_research.6a750c77.png";